import React from "react"
import BibleForce from "../Components/BibleForce/BibleForce"
import {globals} from "../Components/Globals/Globals"

const PrivacyPageView = () => {
    return(
        <div className="privacy-page-container">
            {/* Full width main picture */}
            <div className="top-banner-image">
                <div className="nested-title dark">{globals.menu.privacy}</div>
            </div>

            <div className="body-page-container">
                {/* Laïus introduction de la page*/}
                <div className="welcome-title">
                    <div>
                    Politique de Confidentialité
                    </div>
                </div>

                <div className='bible-container'>

<h2>1. Introduction</h2>

Bienvenue dans notre application <strong>{globals.parameters.app_name}</strong>. Nous nous engageons à protéger la vie privée de nos utilisateurs, en particulier des enfants de moins de 13 ans. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons les informations personnelles des utilisateurs de notre application.

<h2>2. Collecte des Informations</h2>

Nous ne collectons pas sciemment d'informations personnelles identifiables auprès des enfants de moins de 13 ans. Les informations que nous collectons sont limitées et utilisées uniquement pour améliorer l'expérience utilisateur. Voici les types d'informations que nous pouvons collecter :
<ul>
<li><strong>Informations Non Personnelles</strong> : Nous pouvons collecter des informations non personnelles telles que le type d'appareil, le système d'exploitation, et d'autres données anonymes.</li>
<li><strong>Informations de Localisation</strong> : Avec votre consentement, nous pouvons collecter des informations de localisation pour fournir des fonctionnalités spécifiques de l'application.</li>
</ul>
<h2>3. Utilisation des Informations</h2>

Les informations collectées sont utilisées pour :

<ul>
<li>Améliorer et personnaliser l'expérience utilisateur.</li>
<li>Fournir des fonctionnalités spécifiques de l'application.</li>
<li>Assurer la sécurité et la conformité de l'application.</li>
</ul>

<h2>4. Partage des Informations</h2>

Nous ne vendons, n'échangeons ni ne transférons vos informations personnelles à des tiers. Cependant, nous pouvons partager des informations non personnelles avec des partenaires de confiance pour améliorer nos services.

<h2>5. Sécurité des Informations</h2>

Nous mettons en œuvre des mesures de sécurité appropriées pour protéger les informations collectées contre tout accès non autorisé, altération, divulgation ou destruction.

<h2>6. Droits des Parents</h2>

Les parents ou tuteurs légaux peuvent nous contacter pour examiner les informations personnelles de leur enfant, demander leur suppression, ou refuser toute collecte ultérieure d'informations. Pour ce faire, veuillez nous contacter à <b>{globals.parameters.contact_email_store}</b>.

<h2>7. Modifications de la Politique de Confidentialité</h2>

Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications seront publiées sur cette page et prendront effet immédiatement.

<h2>8. Contact</h2>

Si vous avez des questions ou des préoccupations concernant cette politique de confidentialité, veuillez nous contacter à <b>{globals.parameters.contact_email_store}</b>.

                </div>                
            </div>
        </div>
    )
}

export default PrivacyPageView;